<style>
    #socialShareModal .btn-share{
        font-size: 22px;
        height: 48px;
        width: 48px;
        text-align: center;
        border-radius: 50%;
        padding: 0;
    }
    #socialShareModal .custom-image{
        height: 188px;
        object-fit: contain;
        border-radius: 9px;
    }
</style>

<script>
    export default {
        props: ['url', 'title', 'image_url'],
        data: function () {
            return {
                default_title: 'Share this page',
                default_url: '',
                custom_url: '',
                custom_title: '',
                custom_image_url: ''
            };
        },
        created: function () {
            this.default_url = window.location.href;
        },
        mounted: function () {
            var self = this;
            
            document.getElementById('socialShareModal').addEventListener('show.bs.modal', function (event) {
                self.default_url = window.location.href;
            });

            window.bus.$on('social-share', function(data){
                if(data){
                    if(data.url){
                        self.custom_url = data.url;
                    }
                    if(data.title){
                        self.custom_title = data.title;
                    }
                    if(data.image_url){
                        self.custom_image_url = data.image_url;
                    }
                }
                $('#socialShareModal').modal('show');
            });
        },
        computed: {
            __url: function(){
                var url = this.url || this.custom_url;
                if(url){
                    if(url[0] === '/'){
                        //Url is a relative path
                        url = window.location.origin + url;
                    }
                    return url;
                }
                
                return this.default_url;
            },
            __title: function(){
                return this.title || this.custom_title || this.default_title;
            },
            encoded_url: function(){
                return encodeURIComponent(this.__url);
            },
            custom_image: function(){
                return this.image_url || this.custom_image_url;
            }
        },
        watch: {
            
        },
        methods: {
            copyLink: function(){
                if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                    var input = document.getElementById("socialShareUrlInput");
                    input.select();
                    try {
                        return document.execCommand("copy");  // Security exception may be thrown by some browsers.
                    }
                    catch (ex) {
                        this.showMessage('Copy failed'); 
                        return false;
                    }
                } else {
                   this.showMessage('Copy failed'); 
                }
            },
            twitterShare: function(){
                let url = this.encoded_url;
                let share_url = `https://twitter.com/intent/tweet?url=${url}`;
                window.open(share_url);
            },
            facebookShare: function(){
                FB.ui({
                    method: 'share',
                    href: this.__url,
                }, function(response){});
            },
            facebookShareAlt: function(){
                let app_id = $('[name=fb_app_id]').val();
                let href = this.encoded_url;
                let redirect_uri = this.encoded_url;
                let share_url = `https://www.facebook.com/dialog/share?app_id=${app_id}&display=popup&href=${href}`;
                window.open(share_url);
            },
            emailShare: function(){
                let url = this.encoded_url;
                window.open('mailto:?body=' + url);
            },
            pinterestShare: function(){
                let url = this.encoded_url;
                let share_url = `https://www.pinterest.com/pin/create/link/?url=${url}`;
                window.open(share_url);
            },
            tumblrShare: function(){
                let url = this.encoded_url;
                let share_url = `https://www.tumblr.com/widgets/share/tool/preview?canonicalUrl=${url}`;
                window.open(share_url);
            },
            whatsappShare: function(){
                let text = this.encoded_url;
                let share_url = `https://api.whatsapp.com/send/?phone&text=${text}&app_absent=0`;
                window.open(share_url);
            },
            showMessage: function(text){
                if(typeof window.Snackbar === 'object'){
                    Snackbar.show({
                        text: text,
                        pos: 'top-center',
                        duration: 6000
                    });
                } else {
                    alert(text);
                }
            }
        },
        filters: {

        }
    };
</script>

<template>
    <div class="modal" id="socialShareModal">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times fa-sm"></i>
                    </button>
                </div>
                <div class="modal-body pt-0">
                    <h3 class="modal-title style-section-title text-center mb-4">{{__title}}</h3>
                    <div class="text-center my-4" v-if="custom_image">
                        <img class="custom-image" :src="custom_image">
                    </div>
                    <div class="row row-sm mb-4 justify-content-center">
                        <div class="col-auto">
                            <button class="btn btn-share btn-twitter mb-2 mr-2" @click="twitterShare" title="Twitter">
                                <i class="fab fa-fw fa-twitter"></i>
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-share btn-facebook mb-2 mr-2" @click="facebookShareAlt" title="Facebook">
                                <i class="fab fa-fw fa-facebook-f"></i>
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-share btn-border mb-2 mr-2" @click="emailShare" title="Email">
                                <i class="fas fa-fw fa-envelope"></i>
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-share btn-pinterest mb-2 mr-2" @click="pinterestShare" title="Pinterest">
                                <i class="fab fa-fw fa-pinterest"></i>
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-share btn-tumblr mb-2 mr-2" @click="tumblrShare" title="Tumblr">
                                <i class="fab fa-fw fa-tumblr"></i>
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-share btn-whatsapp mb-2" @click="whatsappShare" title="WhatsApp">
                                <i class="fab fa-fw fa-whatsapp"></i>
                            </button>
                        </div>
                    </div>
                    <div class="form-group row no-gutters">
                        <div class="col mr-1">
                            <input id="socialShareUrlInput" type="text" class="form-control" readonly :value="__url">
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-primary" @click="copyLink">Copy Link</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/socialShare.vue